<template>
    <div id="update-diagnosis-container">
        <BaseModal
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="title"
            :width="'40%'"
            height="auto"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK }
            ]"
            @Close="close"
        >
            <div id="dialog-body-contaniner">
                <b-row>
                    <b-col lg="4" md="4" sm="12">
                        <MdDateTime
                            :Label="$t('Shared.ServiceDate')"
                            :Model="editableItem.serviceDate"
                            @input="editableItem.serviceDate = $event"
                            :Id="'service-date'"
                            :Type="'date'"
                            :isRequired="false"
                            :isConfirm="false"
                            :ReadOnly="true"
                        >
                        </MdDateTime>
                    </b-col>
                </b-row>
                <MdTitle v-bind:Text="$t('PatientClaimList.DiagCode')" v-bind:isSubtitle="true" />
                <b-row>
                    <b-col lg="12" md="12" sm="12">
                        <MdCheckListBox2
                            v-model="diagnosisModel"
                            :OnChangeProp="onChangeDiagnosis"
                            :Options="diagnosisList"
                            :Height="'150px'"
                            :columnCount="1"
                            :textField="'description'"
                            :valueField="'code'"
                            :ShowSelectAll="true"
                            :isValid="diagnosisModel.length <= 4"
                        />
                    </b-col>
                </b-row>
            </div>
        </BaseModal>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';

export default {
    name: 'DiagnosisUpdateModal',
    mixins: [ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        diagnosisList: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        },
        value(newVal) {
            this.editableItem = { ...newVal };
            this.editableClone = { ...newVal };
            this.diagnosisModel = this.editableItem.diagnosticCode
                ? this.editableItem.diagnosticCode.split(',')
                : [];
        }
    },

    computed: {
        title() {
            return `${this.editableItem?.name}`;
        }
    },

    data() {
        return {
            modalId: 'DateRangeAttendanceModal',
            emitCloseEvent: false,
            editableItem: { ...this.value },
            editableClone: { ...this.value },
            diagnosisModel: []
        };
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent = false;
            this.$emit('update:visible', false);

            this.cleanWithClone();
        },

        emitEventOK(bvModalEvent) {
            if (this.validate()) {
                this.$emit('update:visible', false);
                this.$emit('ok', this.editableItem);
            } else {
                bvModalEvent.preventDefault();
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('DateRangeAttendance.DiagMaxError'),
                    'errorAutoHide'
                );
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;

                this.cleanWithClone();
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate() {
            return this.diagnosisModel.length <= 4;
        },

        onChangeDiagnosis(values) {
            this.editableItem.diagnosticCode = values.join(',');
        },

        cleanWithClone() {
            this.editableItem = { ...this.editableClone };
            this.diagnosisModel = this.editableItem.diagnosticCode
                ? this.editableItem.diagnosticCode.split(',')
                : [];
        }
    }
};
</script>
